module.exports = __webpack_public_path__ + "static/media/Portal_BG_v1.bfef442d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/login/Portal_BG_v1.jpg
// module id = 841
// module chunks = 0